export default [
  {
    path: "/kys-ekipman-bakim-plani",
    name: "kys-ekipman-bakim-plani",
    component: () => import("@/views/kys-ekipman-bakim/EkipmanBakimListesi.vue"),
    meta: { public: false, title: "kys_ekipman_bakim.ekipman_bakim_plani", yetki: { k: [1190802] } },
  },
]
